export default __webpack_public_path__ + "static/media/sun-arrow-down.19625be8.svg";